import alt from 'alt'
import { createActions } from 'alt-utils/lib/decorators'
import { CheckSource, CheckDetailSource, NotFoundCheckDetailSource } from 'sources'
import { UserActions, Analytics } from 'common-frontend'
import Enum from 'utils/Enum'

@createActions(alt)
export default class CheckActions {
  constructor() {
    this.generateActions(
      'setChecks',
      'activatingCheck',
      'checkActivated',
      'updatingCheck',
      'checkUpdated',
      'setCheckStatus',
      'setCheckActivated'
    )
  }

  // simply fetch the check data from the database
  fetch() {
    return CheckSource.getSetups()
      .then(setups => {
        CheckSource.getChecks()
          .then(checks => {
            this.setChecks({ setups, checks })
          })
      })
  }

  // fetch the check data and execute all those that are enabled
  fetchAndRefresh(isPlus) {
    return CheckSource.getSetups()
      .then(setups => {
        CheckSource.getChecks()
          .then(checks => {
            checks.forEach(check => {
              if (!check.enabled || check.onlyForPlus && !isPlus) return

              check.executeResult = null
              CheckDetailSource.get({ id: check.typeId, refresh: true })
                .then(({ id, result, refresh }) => {
                  this.updateCheckStatus({
                    typeId:          id,
                    verdict:         result.verdict,
                    verdictFriendly: result.verdictFriendly,
                    executeResult:   result.executeResult,
                    exception:       result.exception
                  })
                })
            })
            this.setChecks({ setups, checks })
          })
      })
  }

  activate(key, typeId, data, currentUser) {
    this.activatingCheck()

    return CheckSource.activate({ type_id: typeId, ...data })
      .then(check => {
        Analytics.track('Enabled check', {
          advisorType: Enum.CheckTypes[key].advisorType
        })
        if (key === Enum.CheckTypes.seoproblems.key) {
          currentUser.website = data.url // reflect what has happened on the server without refreshing the whole user
          UserActions.setExtendedUser(currentUser)
        }
        this.checkActivated(typeId)
      })
  }

  deactivate(checkId) {
    return CheckSource.update(checkId, { enabled: false })
      .then(resp => {
        let check = Enum.getCheckFromId(resp.typeId) // could tidy up API to make the req/resp types consistent
        Analytics.track('Disabled check', {
          advisorType: check.advisorType
        })
        this.checkUpdated(resp)
        this.setCheckActivated(false)
      })
  }

  updateCheckStatus({ typeId, verdict, verdictFriendly, executeResult, exception }) {
    let check = Enum.getCheckFromId(typeId)
    let checkVerdict = check.advisorType + '_Verdict'
    Analytics.identify({
      [checkVerdict]: verdict
    })
    this.setCheckStatus({ typeId, verdict, verdictFriendly, executeResult, exception })
    return {}
  }
}



// WEBPACK FOOTER //
// ./app/actions/CheckActions.js